import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { modalCloseIcon } from "../../../../../images";
import AutoCompleteField from "../../../../../components/AutoCompleteField/AutoCompleteField";
import "./billingPopUp.scss";
import FullWidthTextField from "../../../../../components/TextField/FullWidthTextField";
import { TextField } from "@mui/material";
import style from "../../../../../pages/BusinessAccountDetails/businessAccountDetails.module.scss";
import { useWindowSize } from "react-use";
import Joi from "joi";
import { useNavigate } from "react-router-dom";
import config from "../../../../../config/config";
import http from "../../../../../helpers/http";
import { chooseYourPlan } from "../../../../../components/helpers/constant-words";
import { useBusinessContext } from "../../../../../context/BusinessAccount/BusinessAccountState";
import useTheme from "../../../../../components/useTheme/useTheme";
// ./businessAccountDetails.module.scss
const BillingPopUp = ({ show, handleClose }) => {
  const {theme} = useTheme()
  const { width } = useWindowSize();
  const lightTheme = true;
  const [values, setValues] = useState({
    billingName: "",
    address_1: "",
    address_2: "",

    country: "",
    state: "",
    city: "",
    pincode: "",
    gstNo: "",
  });
  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const navigate = useNavigate();

  const { data: businessData, update, fetchData } = useBusinessContext();

  const base_url = config.api_url; //without trailing slash
  const schema = Joi.object({
    billingName: Joi.string().trim().required().label("Billing Name"),
    address_1: Joi.string().trim().required().label("Address"),

    country: Joi.string().trim().required().label("Country"),
    state: Joi.string().trim().required().label("State"),
    city: Joi.string().trim().required().label("City"),
    pincode: Joi.number().required().label("Pincode"),

    gstNo: Joi.string().trim().allow("").min(15).max(15).label("GST No"),
  }).options({ allowUnknown: true });

  const validate = async (data) => {
    const { error } = schema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
      errors: {
        wrap: {
          label: "",
        },
      },
    });

    const errors = {};

    if (error) {
      error.details.map((field) => {
        errors[field.path[0]] = field.message;
        return true;
      });
    }

    return errors ? errors : null;
  };

  const handleSubmit = async (e) => {
    console.log("form submit");

    e.preventDefault();
    // console.log(values);
    let errors = await validate(values);
    setFormError(errors);

    console.log({ errors });
    if (Object.keys(errors).length) {
      return;
    }

    setLoading(true);

    // console.log(...formData);
    // return;

    const response = await http.put(
      `${config.api_url}/business-plans/billing-details/${businessData?._id}`,
      values
    );

    if (response?.data) {
      setValues({
        billingName: "",
        address_1: "",
        address_2: "",

        country: " ",
        state: " ",
        city: " ",
        pincode: "",
        gstNo: "",
      });

      //referesh business context data

      await fetchData(businessData?._id);

      navigate(chooseYourPlan);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setValues((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else {
      let newValue = value;

      if (name === "gstNo") {
        newValue = newValue.toUpperCase();
      }

      setValues((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));
    }
  };

  const handleSelectChange = async (value, fieldName) => {
    setValues((prevState) => {
      let newState = {
        ...prevState,
        [fieldName]: value,
      };

      return newState;
    });
  };

  const fetchCountires = async () => {
    const { data } = await http.get(base_url + "/general/countries");

    if (data) {
      setCountries(data);
    }
  };

  const fetchStates = async (country_id) => {
    const { data } = await http.get(base_url + "/general/states/" + country_id);

    if (data) {
      setStates(data);
    }
  };
  const fetchCities = async (state_id) => {
    const { data } = await http.get(base_url + "/general/cities/" + state_id);

    if (data) {
      setCities(data);
    }
  };

  useEffect(() => {
    fetchCountires();
  }, []);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className={`excel_popup where_we_excel--modal billing-popup---cr ${theme === "dark" && "billing-popup--dark-mode"}`}
     backdropClassName={`custom-backdrop ${
          theme === "dark" && "custom_backdrop_billing-popup--dark-mode"
        }`}
    >
      <Modal.Header>
        <button className="custom-cancel-btn" onClick={handleClose}>
          <img
            src={modalCloseIcon}
            alt="close"
            className="ctm_img_bussine_edit_about"
          />
        </button>
      </Modal.Header>

      <Modal.Body>
        <h2 className="about_modal_bussines_heading">Enter Billing Details</h2>

        <div className="excel_select_container conatiner">
          <form onSubmit={handleSubmit} noValidate autoComplete="off">
            <div className="row">
              <div
                className={`col-12 form_col ${width > 767 ? "p-0" : "p-0"} `}
              >
                <div className="field_wrapper">
                  <FullWidthTextField
                    type="text"
                    label="Billing Name*"
                    lightTheme={theme === "dark" ? false : true}
                    name="billingName"
                    value={values.billingName}
                    onChange={handleChange}
                  />
                  <div className="error_wrapper">
                    <p className="error">{formError.billingName}</p>
                  </div>
                </div>
              </div>

              <div
                className={`col-md-6 form_col ${width > 767 ? "ps-0" : "p-0"} `}
              >
                <div className="field_wrapper">
                  <AutoCompleteField
                    key="Country"
                    textLabel="Country*"
                    lightTheme={theme === "dark" ? false : true}
                    data={countries}
                    onChange={(e, option) => {
                      handleSelectChange(option.value, "country");
                      fetchStates(option.id);
                    }}
                  />
                  <div className="error_wrapper">
                    <p className="error">{formError.country}</p>
                  </div>
                </div>
              </div>

              <div
                className={`col-md-6 form_col  ${
                  width > 767 ? "pe-0" : "p-0"
                } `}
              >
                <div className="field_wrapper">
                  <AutoCompleteField
                    key="State"
                    textLabel="State*"
                    lightTheme={theme === "dark" ? false : true}
                    data={states}
                    onChange={(e, option) => {
                      handleSelectChange(option.value, "state");
                      fetchCities(option.id);
                    }}
                  />
                  <div className="error_wrapper">
                    <p className="error">{formError.state}</p>
                  </div>
                </div>
              </div>

              <div
                className={`col-md-6 form_col  ${
                  width > 767 ? "ps-0" : "p-0"
                } `}
              >
                <div className="field_wrapper">
                  <AutoCompleteField
                    key="City"
                    textLabel="City*"
                    lightTheme={theme === "dark" ? false : true}
                    data={cities}
                    onChange={(e, option) => {
                      handleSelectChange(option.value, "city");
                    }}
                  />
                  <div className="error_wrapper">
                    <p className="error">{formError.city}</p>
                  </div>
                </div>
              </div>
              <div
                className={`col-md-6 form_col  ${
                  width > 767 ? "pe-0" : "p-0"
                } `}
              >
                <div className="field_wrapper">
                  <FullWidthTextField
                    type="tel"
                    label="Pincode*"
                   lightTheme={theme === "dark" ? false : true}
                    name="pincode"
                    value={values.pincode}
                    onChange={handleChange}
                  />
                  <div className="error_wrapper">
                    <p className="error">{formError.pincode}</p>
                  </div>
                </div>
              </div>

              <div
                className={`col-md-6 form_col  ${
                  width > 767 ? "ps-0" : "p-0"
                } `}
              >
                <div className="field_wrapper">
                  <FullWidthTextField
                    type="text"
                    label="Address Line 1*"
                    lightTheme={theme === "dark" ? false : true}
                    name="address_1"
                    value={values.address_1}
                    onChange={handleChange}
                  />
                  <div className="error_wrapper">
                    <p className="error">{formError.address_1}</p>
                  </div>
                </div>
              </div>
              <div
                className={`col-md-6 form_col  ${
                  width > 767 ? "pe-0" : "p-0"
                } `}
              >
                <div className="field_wrapper">
                  <FullWidthTextField
                    type="text"
                    label="Address Line 2"
                    lightTheme={theme === "dark" ? false : true}
                    name="address_2"
                    value={values.address_2}
                    onChange={handleChange}
                  />
                  <div className="error_wrapper">
                    <p className="error">{formError.address_2}</p>
                  </div>
                </div>
              </div>

              <hr />
              <div
                className={`col-12 form_col  ${width > 767 ? "p-0" : "p-0"} `}
              >
                <div className="field_wrapper gst_wrapper_bl ">
                  <FullWidthTextField
                    type="text"
                    label="GST No"
                    lightTheme={theme === "dark" ? false : true}
                    name="gstNo"
                    value={values.gstNo}
                    onChange={handleChange}
                  />
                  <div className="error_wrapper">
                    <p className="error">{formError.gstNo}</p>
                  </div>
                </div>
              </div>
            </div>

            <button type="submit" className="popup_common_btn">
              {loading ? "Loading.." : "Proceed"}
            </button>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BillingPopUp;
